import { Component, Inject, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { MAT_DIALOG_DATA } from '@angular/material';
import moment from 'moment';

@Component({
  selector: 'app-salary-dialog',
  templateUrl: './salary-dialog.component.html',
  styleUrls: ['./salary-dialog.component.less']
})

export class SalaryDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  nowLoading = true;

  calendarDays: any[] = [];

  weekList = ['日', '月', '火', '水', '木', '金', '土'];

  // 物件ごとの情報
  siteList = [];

  // 表示する物件シーケンス
  isShows = [];

  constructor(private http: HttpClient, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.createCalendar();
    this.getData();
  }

  /**
   * カレンダー生成
   */
  createCalendar() {

    const calendarDays = [];

    // 月初
    const startDate = moment(this.data['yearMonth'] + '-01').startOf('month');

    // 月末
    const endDate = moment(startDate).endOf('month');

    // 日曜始まり位置
    const startWeek = startDate.day();

    // 空白
    for (let i = 0; i < startWeek; i++) {
      calendarDays.push(null);
    }

    // 当月日付
    let date = startDate.clone();
    // console.log(this.data)

    while (date.isSameOrBefore(endDate, 'day')) {

      const day = date.date()

      const holidayData = this.data['holidays'].find((h) => {
        return h.holiday == day
      })

      let holiday = false
      let holidayNote = null

      if (holidayData && holidayData.holiday) {
        holiday = true
        holidayNote = holidayData.note
      }

      calendarDays.push({
        day,
        date: date.format('YYYY-MM-DD'),
        list: [],
        holiday,
        holidayNote
      });

      date.add(1, 'day');
    }

    this.calendarDays = calendarDays

  }

  /**
   * 表示する情報を取得
   */
  getData() {
    this.nowLoading = true
    this.siteList = []
    this.http.get(
      API_BASE_URL + '/api/v1/salary/getDetailCalendar?staffCd='+ this.data['staffDailyCleaning'] + "&yearMonth=" + this.data['yearMonth'],
      {headers: this.headers}
    )
    .subscribe(res => {
      // 日セルのデータ
      const data = res['list']
      // 勤務物件ごとのデータ
      // this.siteList = res['siteList']

      // const totalList = []
      const siteList = {}

      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          const row = data[i];

          if (!siteList[row.sequenceNumber]) {
            this.siteList.push({ ...row, isShow: true })
            this.isShows.push(row.sequenceNumber)
            siteList[row.sequenceNumber] = true
          }

          for (let j = 0; j < this.calendarDays.length; j++) {
            const c = this.calendarDays[j];
            if (c && row.day == c.date) {
              if (row.isOp) {
                row.color = 'op'
              } else {
                // 休み
                if (row.status) {
                  row.color = 'holiday'

                  // 有休
                  if (row.phHours) {
                    row.color = 'paid'
                  }
                // 通常勤務
                } else {
                  row.color = 'daily'
                }
              }
              c.list.push(row)
            }
          }
        }
      }
      this.nowLoading = false
    },
    error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 表示非表示変更
   */
  changeIsShow() {
    const res = []
    this.siteList.forEach(s => {
      if (s.isShow) {
        res.push(s.sequenceNumber)
      }
    });

    this.isShows = res
  }
}


